import { useState, useEffect } from 'react';

const useBannerData = () => {
  const [banners, setBanner] = useState([]);
  const [loadingBanner, setLoading] = useState(true);
  const [errorBanner, setError] = useState(null);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
         const response = await fetch(`https://backend.nuhababy.com/banner`);
      //  const response = await fetch(`https://nuhababy.com/api/banner`);
        if (!response.ok) {
          throw new Error("Failed to fetch ");
        }
        const data = await response.json();
        setBanner(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  return { banners, loadingBanner, errorBanner };
};

export default useBannerData;
